var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: { value: true, title: `Update member` },
      on: { closed: _setup.cancelHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between w-100" },
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.cancelHandler },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: { text: "Update", variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _setup.execLoadedFn(_setup.updateMember)
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(_setup.ValidationObserver, { ref: "createFormRef" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(_setup.CInput, {
              staticClass: "mb-2",
              attrs: {
                label: "Name",
                "label-class": "text-muted small",
                disabled: "",
              },
              model: {
                value: _setup.memberModel.name,
                callback: function ($$v) {
                  _vm.$set(_setup.memberModel, "name", $$v)
                },
                expression: "memberModel.name",
              },
            }),
            _vm._v(" "),
            _c(_setup.CInput, {
              staticClass: "mb-2",
              attrs: {
                label: "Email",
                "label-class": "text-muted small",
                disabled: "",
              },
              model: {
                value: _setup.memberModel.email,
                callback: function ($$v) {
                  _vm.$set(_setup.memberModel, "email", $$v)
                },
                expression: "memberModel.email",
              },
            }),
            _vm._v(" "),
            _c(_setup.ValidationProvider, {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ failed }) {
                    return [
                      _c("div", { staticClass: "mb-1" }, [
                        _c("span", { staticClass: "text-muted small" }, [
                          _vm._v("Access level*"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(_setup.CButtonGroup, {
                        attrs: {
                          "no-icon": "",
                          type: "radio",
                          items: _setup.accessTypes,
                          error: failed,
                          "error-msg": "Select the access mode",
                        },
                        model: {
                          value: _setup.memberModel.accessType,
                          callback: function ($$v) {
                            _vm.$set(_setup.memberModel, "accessType", $$v)
                          },
                          expression: "memberModel.accessType",
                        },
                      }),
                      _vm._v(" "),
                      _c("small", { staticClass: "mt-2 text-muted" }, [
                        _vm._v(
                          "\n                    With restricted access, a member can only see allowed templates and the ones they create.\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _setup.memberModel.accessType ==
                      _setup.AccessMode.RESTRICTED
                        ? _c(_setup.CCustomCheckbox, {
                            staticClass: "mt-3",
                            attrs: {
                              label: "Access Account Integrations",
                              switch: "",
                            },
                            model: {
                              value: _setup.memberModel.manageIntegrations,
                              callback: function ($$v) {
                                _vm.$set(
                                  _setup.memberModel,
                                  "manageIntegrations",
                                  $$v
                                )
                              },
                              expression: "memberModel.manageIntegrations",
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }